import { render, staticRenderFns } from "./BudgetToDateStats.vue?vue&type=template&id=4825033b&"
import script from "./BudgetToDateStats.vue?vue&type=script&lang=js&"
export * from "./BudgetToDateStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports